import React from "react";
import { useApp } from "../../context/AppContext";
import { Reveal, Kicker } from "../motion";
import financingStepsImg from "../../assets/sections/financing-steps.webp";

export function HowItWorks() {
  const { c } = useApp();
  const h = c.how;

  return (
    <section data-testid="how-section" className="relative overflow-hidden bg-[#001a40] py-24 text-[#f5f7fa] md:py-32">
      <img
        src={financingStepsImg}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center opacity-65"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,rgba(0,26,64,0.98)_0%,rgba(0,26,64,0.9)_34%,rgba(0,26,64,0.5)_68%,rgba(0,26,64,0.28)_100%)]"
      />
      <div className="relative z-10 mx-auto max-w-[1240px] px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <Kicker tone="cream">{h.kicker}</Kicker>
          <h2 className="mt-5 font-display text-4xl font-bold tracking-tight text-[#f5f7fa] sm:text-5xl">
            {h.title}
          </h2>
        </Reveal>

        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-[#e8a93d]/35 md:block" />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {h.steps.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.1} className="relative">
                <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[#e8a93d]/50 bg-[#001a40]/80 font-display text-lg font-extrabold text-[#e8a93d]">
                  {step.n}
                </div>
                <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-[#f5f7fa]">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#f5f7fa]/70">{step.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
